export default "__VITE_ASSET__BGSZSjs0__"